import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-discount',
  templateUrl: './student-discount.component.html',
  styleUrls: ['./student-discount.component.css']
})
export class StudentDiscountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
